<template>
  <div>
    <h1 class="font-bold my-10">
      {{ $t('nav.deleteAccount') }}
    </h1>
    <div class="delete-account-policy mb-40" v-html="deleteAccountPolicy"></div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'deleteAccount',
  data() {
    return {
      deleteAccountPolicy: '',
    };
  },
  methods: {
    async getDeleteAccountPolicy() {
      try {
        const response = await api.get('info/');
        this.deleteAccountPolicy = response.data['delete_account_policy'] || '';
      } catch (e) {
        console.log(e);
      }
    },
  },
  async created() {
    await this.getDeleteAccountPolicy();
  },
};
</script>

<style scoped>
.delete-account-policy {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.delete-account-policy :deep(*) {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.delete-account-policy :deep(pre) {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  font-family: inherit;
}

.delete-account-policy :deep(img) {
  height: auto;
}

.delete-account-policy :deep(table) {
  display: block;
  overflow-x: auto;
}
</style>
